// extracted by mini-css-extract-plugin
module.exports = {"rowAction":"table_rowAction__1pJ8k"};